/*
 * @Author: wsx
 * @Date: 2021-12-30 15:40:25
 * @LastEditTime: 2022-01-05 10:19:12
 * @LastEditors: your name
 * @Description: 测量
 */

import Overlay from "ol/Overlay";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Style, Fill, Stroke, Circle } from "ol/style";
import Draw from "ol/interaction/Draw";
import { unByKey } from "ol/Observable";
import { getUid } from "ol/util";

import { ElMessage } from "element-plus";
class Measure {
  m = new Map();
  myMap = undefined;
  sketch = undefined;
  taggingState = undefined;
  operationTipsVisible = undefined;
  constructor() {
    this.draw = undefined;
  }

  /**
   * @description: 面积测量
   * @param {*}
   * @return {*}
   */
  distance(myMap) {
    const self = this;
    self.myMap = myMap;
    const i = {};
    const vector = self.createVector();
    self.draw = new Draw({
      source: vector.getSource(), // 测量绘制层数据源
      type: "LineString", // 几何图形类型
      style: self.drawStyle()
    });
    const uid = getUid(self.draw);
    i.vector = vector;

    self.myMap.addLayer(i.vector);
    self.myMap.addInteraction(self.draw);

    self.createMeasureTooltip(i);
    var listener;
    self.tooltip("点击地图开始测量");
    // 绑定交互绘制工具开始绘制的事件
    self.drawstart(i, listener);
    // 绑定交互绘制工具结束绘制的事件
    self.drawend(i, listener, uid);
    self.m.set(uid, i);
  }

  /**
   * @description: 绑定交互绘制工具开始绘制的事件
   * @param {*} uid
   * @param {*} listener
   * @return {*}
   */
  drawstart(i, listener) {
    const self = this;
    var tooltipCoord; // 绘制的坐标
    self.draw.on(
      "drawstart",
      function(evt) {
        // set sketch
        self.sketch = evt.feature; // 绘制的要素
        self.tooltip("单击继续测量，双击结束测量!");
        /** @type {ol.Coordinate|undefined} */
        tooltipCoord = evt.coordinate; // 绘制的坐标
        // 绑定change事件，根据绘制几何类型得到测量长度值或面积值，并将其设置到测量工具提示框中显示
        listener = self.sketch.getGeometry().on("change", function(evt) {
          var geom = evt.target; // 绘制几何要素
          var output = self.formatLength(/** @type {LineString} */ (geom)); // 长度值
          tooltipCoord = geom.getLastCoordinate(); // 坐标
          i.element.innerHTML = output; // 将测量值设置到测量工具提示框中显示
          i.overlay.setPosition(tooltipCoord); // 设置测量工具提示框的显示位置
        });
      },
      this
    );
  }

  /**
   * @description: 绑定交互绘制工具结束绘制的事件
   * @param {*} uid
   * @param {*} listener
   * @return {*}
   */
  drawend(i, listener, uid) {
    const self = this;
    self.draw.on(
      "drawend",
      evt => {
        const close = document.createElement("div");
        close.innerHTML = "x";
        close.className = "tooltip-static-close";
        close.addEventListener("click", function() {
          if (i.overlay) {
            self.myMap.removeOverlay(i.overlay);
          }
          if (i.element) {
            i.element.parentNode.removeChild(i.element);
          }
          self.myMap.removeLayer(i.vector);
          self.m.delete(uid);
        });
        i.element.appendChild(close);
        i.element.className = "tooltip tooltip-static"; // 设置测量提示框的样式
        i.overlay.setOffset([0, -7]);
        self.sketch = null; // 置空当前绘制的要素对象
        i.element = null; // 置空测量工具提示框对象
        // self.createMeasureTooltip(uid);//重新创建一个测试工具提示框显示结果
        self.tooltipClose();
        self.taggingState = 1;
        unByKey(listener);
        self.myMap.removeInteraction(self.draw);
      },
      this
    );
  }

  /**
   * @description: 创建测量图层
   * @param {*}
   * @return {*} VectorLayer
   */
  createVector() {
    var source = new VectorSource(); // 图层数据源
    return new VectorLayer({
      source: source,
      style: new Style({
        // 图层样式
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.2)" // 填充颜色
        }),
        stroke: new Stroke({
          color: "#ffcc33", // 边框颜色
          width: 2 // 边框宽度
        }),
        image: new Circle({
          radius: 7,
          fill: new Fill({
            color: "#ffcc33"
          })
        })
      })
    });
  }

  /**
   * @Description: 清空测量记录
   */
  clearMeasureRecord(myMap) {
    const self = this;
    self.myMap = myMap;
    for (const i of self.m.values()) {
      if (i) {
        const overlay = i.overlay;
        const element = i.element;
        self.myMap.removeOverlay(overlay);
        element.parentNode.removeChild(element);
        self.myMap.removeLayer(i.vector);
      }
    }
    // 重置
    self.$nextTick(_ => {
      self.m.clear();
      self.tooltipClose();
      self.taggingState = 1;
    });
  }

  /**
   * @Description: 取消测量
   */
  cancelMeasure() {
    const self = this;
    self.myMap.removeInteraction(this.draw);
    const uid = getUid(self.draw);
    const i = self.m.get(uid);
    if (i) {
      if (i.overlay) {
        self.myMap.removeOverlay(i.overlay);
      }
      if (i.element) {
        i.element.parentNode.removeChild(i.element);
      }
      self.m.delete(uid);
    }
    self.tooltipClose();
    self.taggingState = 1;
  }

  // 测量样式
  drawStyle() {
    return new Style({
      // 绘制几何图形的样式
      fill: new Fill({
        color: "rgba(255, 255, 255, 0.2)"
      }),
      stroke: new Stroke({
        color: "rgba(0, 0, 0, 0.5)",
        lineDash: [10, 10],
        width: 2
      }),
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(0, 0, 0, 0.7)"
        }),
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.2)"
        })
      })
    });
  }

  /**
   *创建一个新的测量工具提示框（tooltip）
   */
  createMeasureTooltip(i) {
    const self = this;
    if (!i) {
      i = {};
    }
    if (i.element) {
      i.element.parentNode.removeChild(i.element);
    }
    i.element = document.createElement("div");
    i.element.className = "tooltip tooltip-measure";
    i.overlay = new Overlay({
      element: i.element,
      offset: [0, -15],
      positioning: "bottom-center"
    });
    self.myMap.addOverlay(i.overlay);
  }

  /**
   * 测量长度输出
   * @param {ol.geom.LineString} line
   * @return {string}
   */
  formatLength(line) {
    const length = (Math.round(line.getLength() * 100) / 100) * 0.1314; // 直接得到线的长度
    let output;
    if (length > 100) {
      output = Math.round((length / 1000) * 100) / 100 + " " + "km"; // 换算成KM单位
    } else {
      output = Math.round(length * 100) / 100 + " " + "m"; // m为单位
    }
    return output; // 返回线的长度
  }

  /**
   * @Description: 操作提示
   * @param {type}
   */
  tooltip(text) {
    this.tooltipClose();
    this.operationTipsVisible = ElMessage({
      showClose: true,
      duration: 0,
      message: text,
      type: "warning"
    });
  }

  /**
   * @Description: 关闭操作提示
   * @param {type}
   */
  tooltipClose() {
    if (this.operationTipsVisible) {
      this.operationTipsVisible.close();
    }
  }
}
export default Measure;
